import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { persistReducer, persistStore } from 'redux-persist';
import {
  PreloadedState,
  combineReducers,
  configureStore
} from '@reduxjs/toolkit';


import authReducer from './slices/authSlice'

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2
};


const rootReducer = combineReducers({
  auth: authReducer
});

const persistedReducer = persistReducer(
  persistConfig,
  rootReducer
);

export const store = configureStore({
  reducer: persistedReducer
});


export const persistor = persistStore(store);

export const setupStore = (preloadedState) => {
  return store;
};

export const createPreloadedState = (customState) => {
  return {
    auth: { ...store.getState().auth, ...customState.auth }
  };
};